export enum EvSimulatorSteps {
  existingClient = 'existing-client',
  houseType = 'house-type',
  chargingStationPlacement = 'charging-station-placement',
  chargingStationDistance = 'charging-station-distance',
  electricPhase = 'electric-phase',
  contactInfo = 'contact-info',
  personalCalculation = 'personal-calculation',
}

/** Used to determine the progress bar order, Keep up to date when steps change*/
export const evSimulatorStepsOrder: { step: EvSimulatorSteps }[] = [
  { step: EvSimulatorSteps.existingClient },
  { step: EvSimulatorSteps.houseType },
  { step: EvSimulatorSteps.chargingStationPlacement },
  { step: EvSimulatorSteps.chargingStationDistance },
  { step: EvSimulatorSteps.electricPhase },
  { step: EvSimulatorSteps.contactInfo },
];
